export function getInitialsFromName(name: string | null | undefined, fallback = '?'): string {
  const cleaned = (name ?? '')
    .replace(/^dr\.?\s*/i, '')
    .replace(/^dokter\s+/i, '')
    .trim();
  if (!cleaned) return fallback;
  const parts = cleaned.split(/\s+/).filter(Boolean);
  return parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '').join('') || fallback;
}

export function getDoctorInitials(doctor: { first_name?: string | null; last_name?: string | null }): string {
  return `${doctor.first_name?.[0] ?? ''}${doctor.last_name?.[0] ?? ''}`.toUpperCase() || 'Dr';
}
